(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[330],{

/***/ 29792:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...slug]",
      function () {
        return __webpack_require__(63332);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 40790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var Custom404 = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "page empty-results not-found-404",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "info",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h6", {
                        className: "page-title",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                className: "fal fa-exclamation-circle"
                            }),
                            " Page Not Found"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "help",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "The link you followed is broken, or the page has been removed. Here is what you can do:"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "help-elements",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: "/",
                                        as: "/",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                            className: "help-element",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                    className: "fas fa-home"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: "Go to Homepage"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        className: "help-element",
                                        href: "tel:+18002288379",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: "fad fa-phone"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: "Call help at 1-800-228-8379"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        className: "help-element",
                                        href: "mailto:info@1800battery.com?Subject=Inquiry%20from%20Website",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: "fad fa-envelope",
                                                "aria-hidden": "true"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: "Get in touch with our support"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Custom404);


/***/ }),

/***/ 63332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(26626);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./pages/404.jsx
var _404 = __webpack_require__(40790);
// EXTERNAL MODULE: ./src/functions/getGoogleCriteronProps.js
var getGoogleCriteronProps = __webpack_require__(86792);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/has.js
var has = __webpack_require__(18721);
var has_default = /*#__PURE__*/__webpack_require__.n(has);
// EXTERNAL MODULE: ./node_modules/lodash/map.js
var map = __webpack_require__(35161);
var map_default = /*#__PURE__*/__webpack_require__.n(map);
// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./src/utils/index.js + 7 modules
var utils = __webpack_require__(2277);
;// CONCATENATED MODULE: ./src/components/Action.jsx










var Action = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Action, _Component);
    var _super = (0,_create_super/* default */.Z)(Action);
    function Action() {
        (0,_class_call_check/* default */.Z)(this, Action);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(Action, [
        {
            key: "render",
            value: function render() {
                var action = this.props.action;
                var targetProps = get_default()(action, "new_window") ? {
                    target: "_blank",
                    rel: "noopener"
                } : null;
                var renderButton = false;
                var hrefAction = (0,utils/* safePrefix */.JF)(get_default()(action, "url"));
                if (action.url.includes("tel:") || action.url.includes("mailto:")) {
                    hrefAction = get_default()(action, "url").replace(/"/g, "");
                    renderButton = true;
                }
                return renderButton ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: hrefAction,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "btn",
                        children: get_default()(action, "label")
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* Link */.rU, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    href: hrefAction
                }, targetProps, this.props.rest), {
                    children: get_default()(action, "label")
                }));
            }
        }
    ]);
    return Action;
}(react.Component);


;// CONCATENATED MODULE: ./src/components/CtaButtons.jsx











var CtaButtons = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(CtaButtons, _Component);
    var _super = (0,_create_super/* default */.Z)(CtaButtons);
    function CtaButtons() {
        (0,_class_call_check/* default */.Z)(this, CtaButtons);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CtaButtons, [
        {
            key: "render",
            value: function render() {
                var actions = get_default()(this.props, "actions");
                if (isEmpty_default()(actions)) {
                    return null;
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "block-buttons",
                    children: map_default()(actions, function(action, actionIdx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Action, {
                            action: action,
                            className: (0,utils/* classNames */.AK)("button", {
                                secondary: !get_default()(action, "primary")
                            })
                        }, actionIdx);
                    })
                });
            }
        }
    ]);
    return CtaButtons;
}(react.Component);


// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/Social.jsx









var Social = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Social, _Component);
    var _super = (0,_create_super/* default */.Z)(Social);
    function Social() {
        (0,_class_call_check/* default */.Z)(this, Social);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(Social, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "social-links",
                    children: map_default()(get_default()(this.props, "socialLinks"), function(action, actionIdx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Action, {
                                action: action
                            })
                        }, actionIdx);
                    })
                });
            }
        }
    ]);
    return Social;
}(react.Component);


;// CONCATENATED MODULE: ./src/components/SubscribeForm.jsx






var SubscribeForm = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(SubscribeForm, _Component);
    var _super = (0,_create_super/* default */.Z)(SubscribeForm);
    function SubscribeForm() {
        (0,_class_call_check/* default */.Z)(this, SubscribeForm);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SubscribeForm, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    name: "subscribeForm",
                    method: "POST",
                    id: "subscribe-form",
                    className: "subscribe-form",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "screen-reader-text",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                children: [
                                    "Don't fill this out if you're human: ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        name: "bot-field"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "form-row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "screen-reader-text",
                                        children: "Email address"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        className: "subscribe-email",
                                        type: "email",
                                        name: "email",
                                        placeholder: "Enter Email Address..."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "hidden",
                            name: "form-name",
                            value: "subscribeForm"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "button",
                            type: "submit",
                            children: "Subscribe"
                        })
                    ]
                });
            }
        }
    ]);
    return SubscribeForm;
}(react.Component);


;// CONCATENATED MODULE: ./src/components/Footer.jsx














var Footer = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Footer, _Component);
    var _super = (0,_create_super/* default */.Z)(Footer);
    function Footer() {
        (0,_class_call_check/* default */.Z)(this, Footer);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(Footer, [
        {
            key: "render",
            value: function render() {
                var config = get_default()(this.props, "config");
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                    id: "colophon",
                    className: "site-footer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "footer-top outer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "inner",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "footer-widgets",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "widget footer-branding",
                                            children: [
                                                get_default()(config, "footer.logo_img") ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "site-logo",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* Link */.rU, {
                                                        href: (0,utils/* safePrefix */.JF)("/"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            objectFit: "contain",
                                                            width: "200px",
                                                            height: "64px",
                                                            src: get_default()(config, "footer.logo_img"),
                                                            alt: "Logo"
                                                        })
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "site-title",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* Link */.rU, {
                                                        href: (0,utils/* safePrefix */.JF)("/"),
                                                        children: get_default()(config, "header.title")
                                                    })
                                                }),
                                                get_default()(config, "footer.tagline") && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "site-description",
                                                    children: get_default()(config, "footer.tagline")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                get_default()(config, "custom_object.question") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        "q: ",
                                                        get_default()(config, "custom_object.question"),
                                                        " a:",
                                                        " ",
                                                        get_default()(config, "custom_object.answer")
                                                    ]
                                                }),
                                                get_default()(config, "partner_companies") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: map_default()(get_default()(config, "partner_companies"), function(company, companyIdx) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                            children: [
                                                                company.company_name,
                                                                " - ",
                                                                company.company_description
                                                            ]
                                                        }, companyIdx);
                                                    })
                                                })
                                            ]
                                        }),
                                        (get_default()(config, "footer.nav_links") && get_default()(config, "footer.has_nav") || get_default()(config, "footer.has_social")) && /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                            className: "widget footer-navigation",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "footer-nav-inside",
                                                children: [
                                                    get_default()(config, "footer.nav_links") && get_default()(config, "footer.has_nav") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "secondary-nav",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                className: "widget-title",
                                                                children: get_default()(config, "footer.nav_title")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                className: "secondary-menu",
                                                                children: map_default()(get_default()(config, "footer.nav_links"), function(action, actionIdx) {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Action, {
                                                                            action: action
                                                                        })
                                                                    }, actionIdx);
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    get_default()(config, "footer.has_social") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "social-nav",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                className: "widget-title",
                                                                children: get_default()(config, "footer.social_title")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Social, {
                                                                socialLinks: get_default()(config, "footer.social_links")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        get_default()(config, "footer.has_subscribe") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "widget footer-subscribe",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: "widget-title",
                                                    children: get_default()(config, "footer.subscribe_title")
                                                }),
                                                get_default()(config, "footer.subscribe_content") && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: (0,utils/* htmlToReact */.vn)(get_default()(config, "footer.subscribe_content"))
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscribeForm, (0,_object_spread/* default */.Z)({}, this.props))
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "site-info outer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "inner",
                                children: [
                                    (0,utils/* htmlToReact */.vn)(get_default()(config, "footer.content")),
                                    "\xa0",
                                    map_default()(get_default()(config, "footer.links"), function(link, linkIdx) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Action, {
                                                    action: link
                                                }, linkIdx),
                                                "."
                                            ]
                                        }, linkIdx);
                                    })
                                ]
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return Footer;
}(react.Component);


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/lodash/trim.js
var trim = __webpack_require__(92742);
var trim_default = /*#__PURE__*/__webpack_require__.n(trim);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ./src/components/Header.jsx














var Header = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Header, _Component);
    var _super = (0,_create_super/* default */.Z)(Header);
    function Header(props) {
        (0,_class_call_check/* default */.Z)(this, Header);
        var _this;
        _this = _super.call(this, props);
        _this.handleWindowResize = _this.handleWindowResize.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.handleRouteChange = _this.handleRouteChange.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.menuOpenRef = /*#__PURE__*/ react.createRef();
        return _this;
    }
    (0,_create_class/* default */.Z)(Header, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                window.addEventListener("resize", this.handleWindowResize, true);
                router_default().events.on("routeChangeStart", this.handleRouteChange);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener("resize", this.handleWindowResize, true);
                router_default().events.off("routeChangeStart", this.handleRouteChange);
            }
        },
        {
            key: "handleWindowResize",
            value: function handleWindowResize() {
                if (get_default()(this.menuOpenRef, "current.offsetParent") === null) {
                    document.body.classList.remove("menu--opened");
                }
            }
        },
        {
            key: "handleRouteChange",
            value: function handleRouteChange() {
                document.body.classList.remove("menu--opened");
            }
        },
        {
            key: "handleMenuOpen",
            value: function handleMenuOpen(event) {
                event.preventDefault();
                document.body.classList.add("menu--opened");
            }
        },
        {
            key: "handleMenuClose",
            value: function handleMenuClose(event) {
                event.preventDefault();
                document.body.classList.remove("menu--opened");
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var config = get_default()(this.props, "config");
                var page = get_default()(this.props, "page");
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                    id: "masthead",
                    className: "site-header outer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "inner",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "site-header-inside",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "site-branding",
                                    children: [
                                        get_default()(config, "header.logo_img") && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "site-logo",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* Link */.rU, {
                                                href: (0,utils/* safePrefix */.JF)("/"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    objectFit: "contain",
                                                    width: "200px",
                                                    height: "64px",
                                                    src: get_default()(config, "header.logo_img"),
                                                    alt: "Logo"
                                                })
                                            })
                                        }),
                                        get_default()(page, "_type") === "landing" || get_default()(page, "_type") === "blog" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "site-title",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* Link */.rU, {
                                                href: (0,utils/* safePrefix */.JF)("/"),
                                                children: get_default()(config, "header.title")
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "site-title",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* Link */.rU, {
                                                href: (0,utils/* safePrefix */.JF)("/"),
                                                children: get_default()(config, "header.title")
                                            })
                                        })
                                    ]
                                }),
                                get_default()(config, "header.nav_links") && get_default()(config, "header.has_nav") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                            id: "main-navigation",
                                            className: "site-navigation",
                                            "aria-label": "Main Navigation",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "site-nav-inside",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                        id: "menu-close",
                                                        className: "menu-toggle",
                                                        onClick: this.handleMenuClose.bind(this),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "screen-reader-text",
                                                                children: "Open Menu"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "icon-close",
                                                                "aria-hidden": "true"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                        className: "menu",
                                                        children: map_default()(get_default()(config, "header.nav_links"), function(action, actionIdx) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                className: "menu-item" + (trim_default()(get_default()(_this.props, "path"), "/") === trim_default()(get_default()(action, "url"), "/") ? " current-menu-item" : "") + (get_default()(action, "primary") ? " menu-button" : ""),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Action, {
                                                                    action: action,
                                                                    className: get_default()(action, "primary") ? "button" : ""
                                                                })
                                                            }, actionIdx);
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            id: "menu-open",
                                            className: "menu-toggle",
                                            ref: this.menuOpenRef,
                                            onClick: this.handleMenuOpen.bind(this),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "screen-reader-text",
                                                    children: "Close Menu"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "icon-menu",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                });
            }
        }
    ]);
    return Header;
}(react.Component);


// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/components/LayoutSanity.jsx













var Body = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Body, _Component);
    var _super = (0,_create_super/* default */.Z)(Body);
    function Body(props) {
        (0,_class_call_check/* default */.Z)(this, Body);
        var _this;
        _this = _super.call(this, props);
        _this.handleRouteChange = _this.handleRouteChange.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(Body, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var offsetY, ticking;
                    function handleHeader(scrollPos) {
                        if (scrollPos > 0) {
                            document.body.classList.add("has--scrolled");
                        } else {
                            document.body.classList.remove("has--scrolled");
                        }
                    }
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        offsetY = 0;
                        ticking = false;
                        window.addEventListener("scroll", function(e) {
                            offsetY = window.scrollY;
                            if (!ticking) {
                                window.requestAnimationFrame(function() {
                                    handleHeader(offsetY);
                                    ticking = false;
                                });
                                ticking = true;
                            }
                        });
                        router_default().events.on("routeChangeStart", _this.handleRouteChange);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                router_default().events.off("routeChangeStart", this.handleRouteChange);
            }
        },
        {
            key: "handleRouteChange",
            value: function handleRouteChange() {}
        },
        {
            key: "render",
            value: function render() {
                var page = get_default()(this.props, "page");
                var title = (has_default()(page, "title") ? get_default()(page, "title") + " - " : "") + get_default()(this.props, "config.title");
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    charSet: "utf-8"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    name: "viewport",
                                    content: "width=device-width, initialScale=1.0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    name: "google",
                                    content: "notranslate"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                    href: "https://fonts.googleapis.com/css?family=Nunito+Sans:400,400i,700,700i&display=optional",
                                    rel: "stylesheet"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "page",
                            className: "cms-single-page site palette-" + get_default()(this.props, "config.palette"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                                id: "content",
                                className: "site-content",
                                children: this.props.children
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return Body;
}(react.Component);


;// CONCATENATED MODULE: ./src/components/SectionContact.jsx








var SectionContact = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(SectionContact, _Component);
    var _super = (0,_create_super/* default */.Z)(SectionContact);
    function SectionContact() {
        (0,_class_call_check/* default */.Z)(this, SectionContact);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SectionContact, [
        {
            key: "render",
            value: function render() {
                var section = get_default()(this.props, "section");
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    id: get_default()(section, "section_id"),
                    className: "block contact-block bg-" + get_default()(section, "background") + " outer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "block-header inner-small",
                            children: [
                                get_default()(section, "title") && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "block-title",
                                    children: get_default()(section, "title")
                                }),
                                get_default()(section, "subtitle") && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "block-subtitle",
                                    children: get_default()(section, "subtitle")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "block-content inner-medium",
                            children: [
                                (0,utils/* markdownify */.gI)(get_default()(section, "content")),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                    name: "contactForm",
                                    method: "POST",
                                    id: "contact-form",
                                    className: "contact-form",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "screen-reader-text",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                children: [
                                                    "Don't fill this out if you're human: ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        name: "bot-field"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "form-row",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    htmlFor: "name",
                                                    className: "form-label",
                                                    children: "Name"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    name: "name",
                                                    className: "form-input"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "form-row",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    htmlFor: "email",
                                                    className: "form-label",
                                                    children: "Email address"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "email",
                                                    name: "email",
                                                    className: "form-input"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "form-row",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    htmlFor: "message",
                                                    className: "form-label",
                                                    children: "Message"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                    name: "message",
                                                    className: "form-textarea",
                                                    rows: "7"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "hidden",
                                            name: "form-name",
                                            value: "contactForm"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "form-row form-submit",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                type: "submit",
                                                className: "button",
                                                children: "Send Message"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return SectionContact;
}(react.Component);


;// CONCATENATED MODULE: ./src/components/SectionContent.jsx










var SectionContent = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(SectionContent, _Component);
    var _super = (0,_create_super/* default */.Z)(SectionContent);
    function SectionContent() {
        (0,_class_call_check/* default */.Z)(this, SectionContent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SectionContent, [
        {
            key: "render",
            value: function render() {
                var section = get_default()(this.props, "section");
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    id: get_default()(section, "section_id"),
                    className: "block text-block bg-" + get_default()(section, "background") + " outer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "inner",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid",
                            children: [
                                get_default()(section, "image") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cell block-preview",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        width: "200px",
                                        height: "200px",
                                        objectFit: "contain",
                                        src: get_default()(section, "image"),
                                        alt: get_default()(section, "title")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "cell block-content",
                                    children: [
                                        get_default()(section, "title") && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "block-title underline",
                                            children: get_default()(section, "title")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "block-copy",
                                            children: (0,utils/* markdownify */.gI)(get_default()(section, "content"))
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaButtons, {
                                            actions: get_default()(section, "actions")
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                });
            }
        }
    ]);
    return SectionContent;
}(react.Component);


;// CONCATENATED MODULE: ./src/components/SectionCta.jsx









var SectionCta = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(SectionCta, _Component);
    var _super = (0,_create_super/* default */.Z)(SectionCta);
    function SectionCta() {
        (0,_class_call_check/* default */.Z)(this, SectionCta);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SectionCta, [
        {
            key: "render",
            value: function render() {
                var section = get_default()(this.props, "section");
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    id: get_default()(section, "section_id"),
                    className: "block cta-block bg-accent outer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "inner-large",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "cell block-content",
                                    children: [
                                        get_default()(section, "title") && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "block-title",
                                            children: get_default()(section, "title")
                                        }),
                                        get_default()(section, "subtitle") && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "block-subtitle",
                                            children: get_default()(section, "subtitle")
                                        })
                                    ]
                                }),
                                get_default()(section, "actions") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cell block-buttons",
                                    children: map_default()(get_default()(section, "actions"), function(action, actionIdx) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Action, {
                                            action: action,
                                            className: "button white large"
                                        }, actionIdx);
                                    })
                                })
                            ]
                        })
                    })
                });
            }
        }
    ]);
    return SectionCta;
}(react.Component);


;// CONCATENATED MODULE: ./src/components/SectionFaq.jsx









var SectionFaq = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(SectionFaq, _Component);
    var _super = (0,_create_super/* default */.Z)(SectionFaq);
    function SectionFaq() {
        (0,_class_call_check/* default */.Z)(this, SectionFaq);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SectionFaq, [
        {
            key: "render",
            value: function render() {
                var section = get_default()(this.props, "section");
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    id: get_default()(section, "section_id"),
                    className: "block faq-block bg-" + get_default()(section, "background") + " outer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "inner-medium",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "block-header",
                                children: [
                                    get_default()(section, "title") && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "block-title",
                                        children: get_default()(section, "title")
                                    }),
                                    get_default()(section, "subtitle") && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "block-subtitle",
                                        children: get_default()(section, "subtitle")
                                    })
                                ]
                            }),
                            get_default()(section, "faq_items") && /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                                className: "faq-accordion",
                                children: map_default()(get_default()(section, "faq_items"), function(faqItem, faqItemIndex) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                className: "accordion-header",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    className: "accordion-trigger",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "accordion-title",
                                                            children: get_default()(faqItem, "question")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "accordion-icon icon-plus"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                className: "accordion-panel",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "accordion-content",
                                                    children: (0,utils/* markdownify */.gI)(get_default()(faqItem, "answer"))
                                                })
                                            })
                                        ]
                                    }, faqItemIndex);
                                })
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return SectionFaq;
}(react.Component);


;// CONCATENATED MODULE: ./src/components/SectionFeatures.jsx










var SectionFeatures = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(SectionFeatures, _Component);
    var _super = (0,_create_super/* default */.Z)(SectionFeatures);
    function SectionFeatures() {
        (0,_class_call_check/* default */.Z)(this, SectionFeatures);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SectionFeatures, [
        {
            key: "render",
            value: function render() {
                var section = get_default()(this.props, "section");
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    id: get_default()(section, "section_id"),
                    className: "provider-section features",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "header",
                                children: [
                                    get_default()(section, "title") && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: get_default()(section, "title")
                                    }),
                                    get_default()(section, "subtitle") && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "subtitle",
                                        children: get_default()(section, "subtitle")
                                    })
                                ]
                            }),
                            get_default()(section, "features") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "features-inner",
                                children: map_default()(get_default()(section, "features"), function(feature, featureIndex) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "item",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "item-inner",
                                            children: [
                                                get_default()(feature, "image") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "icon",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        width: "200px",
                                                        height: "200px",
                                                        objectFit: "contain",
                                                        src: get_default()(feature, "image"),
                                                        alt: get_default()(feature, "title")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "content",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: "title",
                                                            children: get_default()(feature, "title")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "block-copy",
                                                            children: (0,utils/* markdownify */.gI)(get_default()(feature, "content"))
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, featureIndex);
                                })
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return SectionFeatures;
}(react.Component);


;// CONCATENATED MODULE: ./src/static/images/landing/cover-provider-left.jpg
/* harmony default export */ var cover_provider_left = ({"src":"/_next/static/media/cover-provider-left.9af038a8.jpg","height":913,"width":2189,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAcEAADAAEFAAAAAAAAAAAAAAAAAQIDBQYRIVH/xAAUAQEAAAAAAAAAAAAAAAAAAAAB/8QAGBEAAgMAAAAAAAAAAAAAAAAAAAIBMTL/2gAMAwEAAhEDEQA/AI/dd1eq56p8t2m370AAWhfUn//Z","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./src/static/images/landing/cover-provider-right.jpg
/* harmony default export */ var cover_provider_right = ({"src":"/_next/static/media/cover-provider-right.e31a7c88.jpg","height":913,"width":2189,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAdEAACAgEFAAAAAAAAAAAAAAABAgADBAYRIVGx/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQL/xAAYEQEBAAMAAAAAAAAAAAAAAAABABIhMf/aAAwDAQACEQMRAD8AndGoL8fKps3KK9bgAkchh15ERHJONQCbv//Z","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./src/components/SectionHero.jsx











var SectionHero = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(SectionHero, _Component);
    var _super = (0,_create_super/* default */.Z)(SectionHero);
    function SectionHero() {
        (0,_class_call_check/* default */.Z)(this, SectionHero);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SectionHero, [
        {
            key: "render",
            value: function render() {
                var section = get_default()(this.props, "section");
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    id: get_default()(section, "section_id"),
                    className: "provider-section cover",
                    style: {
                        background: "url(".concat(cover_provider_left, ")")
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "cover-inner",
                        style: {
                            background: "url(".concat(cover_provider_right, ")")
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "shade",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "inner",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "content",
                                        children: [
                                            get_default()(section, "title") && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: get_default()(section, "title")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Becoming a mobile provider for 1-800-Battery can help you make someone's day."
                                            }),
                                            get_default()(section, "actions") && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "block-buttons",
                                                children: map_default()(get_default()(section, "actions"), function(action, actionIdx) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Action, {
                                                        action: action,
                                                        className: "button white large"
                                                    }, actionIdx);
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "border-line"
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                });
            }
        }
    ]);
    return SectionHero;
}(react.Component);


// EXTERNAL MODULE: ./node_modules/lodash/take.js
var take = __webpack_require__(69572);
var take_default = /*#__PURE__*/__webpack_require__.n(take);
// EXTERNAL MODULE: ./node_modules/moment-strftime/lib/moment-strftime.js
var moment_strftime = __webpack_require__(63876);
var moment_strftime_default = /*#__PURE__*/__webpack_require__.n(moment_strftime);
;// CONCATENATED MODULE: ./src/components/PostFooter.jsx












var PostFooter = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(PostFooter, _Component);
    var _super = (0,_create_super/* default */.Z)(PostFooter);
    function PostFooter() {
        (0,_class_call_check/* default */.Z)(this, PostFooter);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(PostFooter, [
        {
            key: "renderCategoryLinks",
            value: function renderCategoryLinks(post) {
                var categories = get_default()(post, "categories");
                if (isEmpty_default()(categories)) {
                    return null;
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        "Categories:",
                        map_default()(categories, function(category, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    index > 0 ? ", " : " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* Link */.rU, {
                                        href: (0,utils/* categoryUrl */.xf)(category),
                                        children: category.title
                                    })
                                ]
                            }, index);
                        })
                    ]
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var post = this.props.post;
                var dateFormat = get_default()(this.props, "dateFormat", "%B %d, %Y");
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                    className: "post-meta",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                            className: "published",
                            dateTime: moment_strftime_default()(get_default()(post, "date")).strftime("%Y-%m-%d %H:%M"),
                            children: moment_strftime_default()(get_default()(post, "date")).strftime(dateFormat)
                        }),
                        has_default()(post, "author") && ", By " + get_default()(post, "author.first_name") + " " + get_default()(post, "author.last_name", ""),
                        this.renderCategoryLinks(post)
                    ]
                });
            }
        }
    ]);
    return PostFooter;
}(react.Component);


;// CONCATENATED MODULE: ./src/components/SectionPosts.jsx









var SectionPosts = function(props) {
    var section = get_default()(props, "section");
    var posts = take_default()(orderBy_default()(get_default()(props, "posts", []), [
        "date"
    ], [
        "desc"
    ]), 3);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: get_default()(section, "section_id"),
        className: "block posts-block bg-" + get_default()(section, "background") + " outer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "block-header inner-small",
                children: [
                    get_default()(section, "title") && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "block-title",
                        children: get_default()(section, "title")
                    }),
                    get_default()(section, "subtitle") && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "block-subtitle",
                        children: get_default()(section, "subtitle")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "inner",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "post-feed",
                    children: map_default()(posts, function(post, postIdx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                            className: "post post-card",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "post-card-inside",
                                children: [
                                    get_default()(post, "thumb_image") && /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* Link */.rU, {
                                        href: (0,utils/* postUrl */.o2)(post),
                                        className: "post-card-thumbnail",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            width: "100px",
                                            height: "100px",
                                            objectFit: "contain",
                                            className: "thumbnail",
                                            src: get_default()(post, "thumb_image"),
                                            alt: get_default()(post, "title")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "post-card-content",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                                                className: "post-header",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "post-title",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* Link */.rU, {
                                                        href: (0,utils/* postUrl */.o2)(post),
                                                        rel: "bookmark",
                                                        children: get_default()(post, "title")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "post-excerpt",
                                                children: (0,utils/* markdownify */.gI)(get_default()(post, "excerpt"))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostFooter, {
                                                post: post
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, postIdx);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_SectionPosts = (SectionPosts);

;// CONCATENATED MODULE: ./src/components/SectionPricing.jsx










var SectionPricing = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(SectionPricing, _Component);
    var _super = (0,_create_super/* default */.Z)(SectionPricing);
    function SectionPricing() {
        (0,_class_call_check/* default */.Z)(this, SectionPricing);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SectionPricing, [
        {
            key: "render",
            value: function render() {
                var section = get_default()(this.props, "section");
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    id: get_default()(section, "section_id"),
                    className: "block pricing-block bg-" + get_default()(section, "background") + " outer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "block-header inner-small",
                            children: [
                                get_default()(section, "title") && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "block-title",
                                    children: get_default()(section, "title")
                                }),
                                get_default()(section, "subtitle") && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "block-subtitle",
                                    children: get_default()(section, "subtitle")
                                })
                            ]
                        }),
                        get_default()(section, "pricing_plans") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inner",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "grid",
                                children: map_default()(get_default()(section, "pricing_plans"), function(pricingPlan, pricingPlanIdx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cell plan" + (get_default()(pricingPlan, "highlight") ? " highlight" : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "plan-inside",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "plan-name",
                                                    children: get_default()(pricingPlan, "title")
                                                }),
                                                get_default()(pricingPlan, "price") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "plan-price",
                                                    children: get_default()(pricingPlan, "price")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "plan-details",
                                                    children: (0,utils/* markdownify */.gI)(get_default()(pricingPlan, "details"))
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaButtons, {
                                                    actions: get_default()(pricingPlan, "actions")
                                                })
                                            ]
                                        })
                                    }, pricingPlanIdx);
                                })
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return SectionPricing;
}(react.Component);


;// CONCATENATED MODULE: ./src/components/SectionReviews.jsx










var SectionReviews = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(SectionReviews, _Component);
    var _super = (0,_create_super/* default */.Z)(SectionReviews);
    function SectionReviews() {
        (0,_class_call_check/* default */.Z)(this, SectionReviews);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SectionReviews, [
        {
            key: "render",
            value: function render() {
                var section = get_default()(this.props, "section");
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    id: get_default()(section, "section_id"),
                    className: "block reviews-block bg-" + get_default()(section, "background") + " outer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "block-header inner-small",
                            children: [
                                get_default()(section, "title") && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "block-title",
                                    children: get_default()(section, "title")
                                }),
                                get_default()(section, "subtitle") && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "block-subtitle",
                                    children: get_default()(section, "subtitle")
                                })
                            ]
                        }),
                        get_default()(section, "reviews") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inner",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "grid",
                                children: map_default()(get_default()(section, "reviews"), function(review, reviewIdx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                                        className: "cell review",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "review-inside",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "review-text",
                                                    children: (0,utils/* htmlToReact */.vn)(get_default()(review, "content"))
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                                                    className: "review-footer",
                                                    children: [
                                                        get_default()(review, "avatar") && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            width: "100px",
                                                            height: "100px",
                                                            objectFit: "contain",
                                                            className: "review-avatar",
                                                            src: get_default()(review, "avatar"),
                                                            alt: "Author avatar"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("cite", {
                                                            className: "review-author",
                                                            children: get_default()(review, "author")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, reviewIdx);
                                })
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return SectionReviews;
}(react.Component);


;// CONCATENATED MODULE: ./src/components/index.js
















/* harmony default export */ var components = ({
    CtaButtons: CtaButtons,
    Footer: Footer,
    Header: Header,
    SectionContact: SectionContact,
    SectionContent: SectionContent,
    SectionCta: SectionCta,
    SectionFaq: SectionFaq,
    SectionFeatures: SectionFeatures,
    SectionHero: SectionHero,
    SectionPosts: components_SectionPosts,
    SectionPricing: SectionPricing,
    SectionReviews: SectionReviews,
    Social: Social,
    SubscribeForm: SubscribeForm,
    LayoutSanity: Body
});

;// CONCATENATED MODULE: ./src/layouts/blog.js















var blog_Blog = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Blog, _Component);
    var _super = (0,_create_super/* default */.Z)(Blog);
    function Blog() {
        (0,_class_call_check/* default */.Z)(this, Blog);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(Blog, [
        {
            key: "render",
            value: function render() {
                var posts = orderBy_default()(get_default()(this.props, "posts", []), [
                    "date"
                ], [
                    "desc"
                ]);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.props), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "outer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inner",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "post-feed",
                                children: map_default()(posts, function(post, postIdx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                        className: "post post-card",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "post-card-inside",
                                            children: [
                                                has_default()(post, "thumb_image") && /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* Link */.rU, {
                                                    href: (0,utils/* postUrl */.o2)(post),
                                                    className: "post-card-thumbnail",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: "thumbnail",
                                                        src: get_default()(post, "thumb_image"),
                                                        alt: get_default()(post, "title")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "post-card-content",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                                                            className: "post-header",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                className: "post-title",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* Link */.rU, {
                                                                    href: (0,utils/* postUrl */.o2)(post),
                                                                    rel: "bookmark",
                                                                    children: get_default()(post, "title")
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "post-excerpt",
                                                            children: (0,utils/* markdownify */.gI)(get_default()(post, "excerpt"))
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostFooter, {
                                                            post: post
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, postIdx);
                                })
                            })
                        })
                    })
                }));
            }
        }
    ]);
    return Blog;
}(react.Component);
// TODO: Generalize function and reuse (V.T. 31.1.2022)


// EXTERNAL MODULE: ./node_modules/lodash/assign.js
var lodash_assign = __webpack_require__(28583);
var assign_default = /*#__PURE__*/__webpack_require__.n(lodash_assign);
// EXTERNAL MODULE: ./node_modules/lodash/filter.js
var filter = __webpack_require__(63105);
var filter_default = /*#__PURE__*/__webpack_require__.n(filter);
// EXTERNAL MODULE: ./node_modules/lodash/includes.js
var includes = __webpack_require__(64721);
var includes_default = /*#__PURE__*/__webpack_require__.n(includes);
;// CONCATENATED MODULE: ./src/layouts/blog_category.js














var Blog = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Blog, _Component);
    var _super = (0,_create_super/* default */.Z)(Blog);
    function Blog() {
        (0,_class_call_check/* default */.Z)(this, Blog);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(Blog, [
        {
            key: "render",
            value: function render() {
                var category = get_default()(this.props, "page.slug");
                var posts = get_default()(this.props, "posts", []);
                posts = filter_default()(posts, function(post) {
                    var postCategories = map_default()(get_default()(post, "categories", []), function(category) {
                        return category.slug;
                    });
                    return includes_default()(postCategories, category);
                });
                posts = orderBy_default()(posts, [
                    "date"
                ], [
                    "desc"
                ]);
                var props = assign_default()({}, this.props, {
                    posts: posts
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_Blog, (0,_object_spread/* default */.Z)({}, props));
            }
        }
    ]);
    return Blog;
}(react.Component);


// EXTERNAL MODULE: ./node_modules/lodash/camelCase.js
var camelCase = __webpack_require__(68929);
var camelCase_default = /*#__PURE__*/__webpack_require__.n(camelCase);
// EXTERNAL MODULE: ./node_modules/lodash/upperFirst.js
var upperFirst = __webpack_require__(11700);
var upperFirst_default = /*#__PURE__*/__webpack_require__.n(upperFirst);
;// CONCATENATED MODULE: ./src/layouts/landing.js













var Landing = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Landing, _Component);
    var _super = (0,_create_super/* default */.Z)(Landing);
    function Landing() {
        (0,_class_call_check/* default */.Z)(this, Landing);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(Landing, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                // TODO: caps - first cap letter can be done via css (V.T. 31.1.2022)
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.props), {
                    children: map_default()(get_default()(this.props, "page.sections"), function(section, section_idx) {
                        var component = upperFirst_default()(camelCase_default()(get_default()(section, "_type")));
                        var Component = components[component];
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _this.props), {
                            section: section
                        }), section_idx);
                    })
                }));
            }
        }
    ]);
    return Landing;
}(react.Component);


;// CONCATENATED MODULE: ./src/layouts/page.js












var Page = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Page, _Component);
    var _super = (0,_create_super/* default */.Z)(Page);
    function Page() {
        (0,_class_call_check/* default */.Z)(this, Page);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(Page, [
        {
            key: "render",
            value: function render() {
                // console.log('www', this.props);
                var page = get_default()(this.props, "page");
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.props), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "inner-medium",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "post-title",
                                        children: get_default()(page, "title")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                    className: "post post-full",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "content",
                                        children: [
                                            has_default()(page, "image") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "post-thumbnail",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: get_default()(page, "image"),
                                                    alt: get_default()(page, "title")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text",
                                                children: [
                                                    has_default()(page, "subtitle") && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: "post-subtitle",
                                                        children: get_default()(page, "subtitle")
                                                    }),
                                                    has_default()(page, "content") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "post-content",
                                                        children: (0,utils/* markdownify */.gI)(get_default()(page, "content"))
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                }));
            }
        }
    ]);
    return Page;
}(react.Component);
// TODO: Generalize function and reuse (V.T. 31.1.2022)


;// CONCATENATED MODULE: ./src/layouts/post.js













var Post = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Post, _Component);
    var _super = (0,_create_super/* default */.Z)(Post);
    function Post() {
        (0,_class_call_check/* default */.Z)(this, Post);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(Post, [
        {
            key: "render",
            value: function render() {
                var page = get_default()(this.props, "page");
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.props), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "outer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inner-medium",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                className: "post post-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                                        className: "post-header",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "post-title",
                                            children: get_default()(page, "title")
                                        })
                                    }),
                                    has_default()(page, "image") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "post-thumbnail",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: get_default()(page, "image"),
                                            alt: get_default()(page, "title")
                                        })
                                    }),
                                    has_default()(page, "subtitle") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "post-subtitle",
                                        children: get_default()(page, "subtitle")
                                    }),
                                    has_default()(page, "content") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "post-content",
                                        children: (0,utils/* markdownify */.gI)(get_default()(page, "content"))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PostFooter, {
                                        post: page,
                                        dateFormat: "%A, %B %e, %Y"
                                    })
                                ]
                            })
                        })
                    })
                }));
            }
        }
    ]);
    return Post;
}(react.Component);


;// CONCATENATED MODULE: ./src/layouts/index.js





/* harmony default export */ var layouts = ({
    landing: Landing,
    page: Page,
    blog: blog_Blog,
    blog_category: Blog,
    post: Post
});

// EXTERNAL MODULE: ./src/redux/actions/geolocation.js
var geolocation = __webpack_require__(47571);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/sourcebit-target-next/with-remote-data-updates.js
var with_remote_data_updates = __webpack_require__(41626);
;// CONCATENATED MODULE: ./pages/[...slug].jsx













//export const config = { amp: true }  --  TODO: NEED TO TEST AMP SETTINGS TO GET AMP - Current Error "The attribute 'href' in tag 'link rel=stylesheet for fonts' is set to the invalid value '/static/nprogress.css'""


 // Only dev live update fires..
var _slug_Page = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Page, _Component);
    var _super = (0,_create_super/* default */.Z)(Page);
    function Page(props) {
        (0,_class_call_check/* default */.Z)(this, Page);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            critChecked: false,
            critId: null
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(Page, [
        {
            key: "checkCrit",
            value: function checkCrit(crit) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var zip_codes, payload;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this.critChecked) return [
                                    3,
                                    4
                                ];
                                if (!crit) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    (0,getGoogleCriteronProps/* default */.Z)(crit)
                                ];
                            case 1:
                                zip_codes = _state.sent();
                                if (!(zip_codes && zip_codes.zipCodes && zip_codes.zipCodes[0])) return [
                                    3,
                                    3
                                ];
                                payload = {
                                    latitude: zip_codes.zipCodes[0].latitude,
                                    longitude: zip_codes.zipCodes[0].longitude,
                                    zipcode: zip_codes.zipCodes[0].zipcode,
                                    address: null,
                                    city: zip_codes.zipCodes[0].cityName,
                                    state: zip_codes.zipCodes[0].stateAbbr,
                                    country: "US",
                                    formatted_address: "".concat(zip_codes.zipCodes[0].cityName, ", ").concat(zip_codes.zipCodes[0].stateAbbr)
                                };
                                return [
                                    4,
                                    _this.props.setLocation(payload)
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                _this.setState({
                                    critId: crit,
                                    critChecked: true
                                });
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var crit;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        if (_this.props.router) {
                            crit = _this.props.router.query.crit;
                            if (crit) {
                                _this.checkCrit(crit);
                            }
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "render",
            value: function render() {
                var PageLayout = layouts[get_default()(this.props, "page._type")];
                if (PageLayout) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLayout, (0,_object_spread/* default */.Z)({}, this.props));
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(_404["default"], {});
            }
        }
    ]);
    return Page;
}(react.Component);
var mapStateToProps = function(state) {
    return {
        geolocation: state.geolocation
    };
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = ((0,with_remote_data_updates/* withRemoteDataUpdates */.G)((0,es/* connect */.$j)(mapStateToProps, {
    setLocation: geolocation/* setLocation */.l6
})(_slug_Page)));


/***/ }),

/***/ 2277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rU": function() { return /* reexport */ utils_link; },
  "xf": function() { return /* reexport */ CategoryUrl; },
  "AK": function() { return /* reexport */ ClassNames; },
  "vn": function() { return /* reexport */ HtmlToReact; },
  "gI": function() { return /* reexport */ Markdownify; },
  "o2": function() { return /* reexport */ PostUrl; },
  "JF": function() { return /* reexport */ SafePrefix; }
});

// UNUSED EXPORTS: withPrefix

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/utils/classNames.js


// TODO: why do we need this? (V.T. 20.12.2021)
function ClassNames() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _classNames;
    return (_classNames = (classnames_default())).call.apply(_classNames, [
        this
    ].concat((0,_to_consumable_array/* default */.Z)(args))) || null;
}

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/react-html-parser/lib/index.js
var lib = __webpack_require__(30653);
;// CONCATENATED MODULE: ./src/utils/htmlToReact.js


// TODO: why do we need this? (V.T. 20.12.2021)
function HtmlToReact(html) {
    if (!html) {
        return null;
    }
    return (0,lib/* default */.ZP)(html, {
        transform: function(node) {
            if (node.type === "script") {
                if (!isEmpty_default()(node.children)) {
                    return "";
                } else {
                    return "";
                }
            }
        }
    });
}

// EXTERNAL MODULE: ./node_modules/marked/lib/marked.esm.js
var marked_esm = __webpack_require__(87441);
;// CONCATENATED MODULE: ./src/utils/markdownify.js


function Markdownify(markdown) {
    if (!markdown) {
        return null;
    }
    return HtmlToReact(marked_esm/* marked.parse */.TU.parse(markdown));
}

// EXTERNAL MODULE: ./node_modules/lodash/startsWith.js
var startsWith = __webpack_require__(10240);
var startsWith_default = /*#__PURE__*/__webpack_require__.n(startsWith);
;// CONCATENATED MODULE: ./src/utils/safePrefix.js

var withPrefix = (__webpack_require__(15629)/* ["default"] */ .Z);
function SafePrefix(url) {
    if (startsWith_default()(url, "#") || startsWith_default()(url, "http")) {
        return url;
    }
    return withPrefix(url);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/utils/link.js






var Link = function(_param) {
    var children = _param.children, href = _param.href, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "href"
    ]);
    // Pass Any internal link to Next.js Link, for anything else, use <a> tag
    var internal = /^\/(?!\/)/.test(href);
    // For root page, use index.js, for rest use [...slug].js
    var page = href === "/" ? "/" : "/[...slug]";
    var slug = href.split("/");
    if (slug.length > 2) {
        if (slug[1] == "category") {
            page = "/category/[categoryid]?categoryid=".concat(slug[2]);
        }
        if (slug[1] == "product") {
            page = "/product/[productid]?productid=".concat(slug[2]);
        }
    }
    if (internal) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: page,
            as: href,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
                children: children
            }))
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        href: href
    }, other), {
        children: children
    }));
};
/* harmony default export */ var utils_link = (Link);

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/trim.js
var trim = __webpack_require__(92742);
var trim_default = /*#__PURE__*/__webpack_require__.n(trim);
;// CONCATENATED MODULE: ./src/utils/postUrl.js


var postUrl_withPrefix = (__webpack_require__(15629)/* ["default"] */ .Z);
function PostUrl(post) {
    var slug = trim_default()(get_default()(post, "slug"), "/");
    return postUrl_withPrefix("/blog/".concat(slug));
}

;// CONCATENATED MODULE: ./src/utils/categoryUrl.js


var categoryUrl_withPrefix = (__webpack_require__(15629)/* ["default"] */ .Z);
// TODO: Generalize function and reuse (V.T. 31.1.2022)
function CategoryUrl(category) {
    var slug = trim_default()(get_default()(category, "slug"), "/");
    return categoryUrl_withPrefix("/blog/category/".concat(slug));
}

// EXTERNAL MODULE: ./src/utils/withPrefix.js
var utils_withPrefix = __webpack_require__(15629);
;// CONCATENATED MODULE: ./src/utils/index.js










/***/ }),

/***/ 15629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WithPrefix; }
/* harmony export */ });
/* harmony import */ var lodash_trimStart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98392);
/* harmony import */ var lodash_trimStart__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_trimStart__WEBPACK_IMPORTED_MODULE_0__);

function WithPrefix(url) {
    var basePath = "";
    return basePath + "/" + lodash_trimStart__WEBPACK_IMPORTED_MODULE_0___default()(url, "/");
}


/***/ }),

/***/ 50247:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,1664,5675,1175,7204,7206,5619,9774,2888,179], function() { return __webpack_exec__(29792); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);